import React from 'react';
import Classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import CenteredPopupContent from '@gamiphy/loyalty-station-desktop/components/promotion/CenteredPopupContent';
import watchExitIntent from '@gamiphy/bl/site/utils';
import { PopupsStore } from '@gamiphy/loyalty-station-desktop/store/popups';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { getThemeFontStyleSheets } from '@gamiphy/loyalty/theme';

const Popup = observer(() => {
  const theme = useTheme();
  const opened = PopupsStore.open;

  React.useEffect(() => {
    if (PopupsStore.shouldOpenOnExit) {
      const removeListener = watchExitIntent({
        threshold: 20,
        eventThrottle: 5,
        onExitIntent: () => {
          PopupsStore.openPopup();
        },
      });
      return () => removeListener();
    }
    return undefined;
  }, [PopupsStore.shouldOpenOnExit]);

  return (
    <div
      className={Classnames()}
      style={{
        display: opened ? 'block' : 'none',
        zIndex: opened ? 2147483648 : -1,
        position: 'relative',
        opacity: opened ? 1 : 0,
        transition: `all 1s ${theme.transitions.easing.easeOut}`,
        height: '100%',
      }}
    >
      <FramePortal
        className="popup-iframe"
        stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
        theme={theme}
        dir={AppStore.dir}
      >
        {PopupsStore.activePopups.length > 0 && <CenteredPopupContent />}
      </FramePortal>
    </div>
  );
});

export default Popup;
